import React, { useEffect, useState } from "react";
import { Tabs, Button } from "antd";
import Main from "../../components/layout/Main";
import TumanentImage from "../../assets/images/tunamnet-tubhnail-image.jpg";
import GamesImage from "../../assets/images/games-image.jpg";
import TrofiesImage from "../../assets/images/trofies-image.svg";
import { useNavigate } from "react-router";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

import { useTournament } from "../../context/TournamentContext";
import { isValidUrl } from "../../helper/functions";
import moment from "moment";
import { ImageNotAvailable } from "../../constants/urls";
import { useAuth } from "../../context/AuthContext";

const PastTournament = () => {
  const [tournaments, setTournaments] = useState([]);
  const [games, setGames] = useState([]);
  const [profile, setProfile] = useState();
  const Navigate = useNavigate();
  const { getProfile } = useAuth();

  const { loadTournaments, filters, updateFilters, loadGames } =
    useTournament();
  // ----------   handlers   -----------
  const fetchTournaments = async (params = {}) => {
    const profileData = await getProfile();
    if (profileData.status === 200) {
      setProfile(profileData.data);
    }

    const response = await loadTournaments(params);
    if (response.status === 200) {
      setTournaments(response.data.data.tournaments);
    }
    const result = await loadGames();
    setGames(result.data.data.uncategorizedGames);
  };

  // ---------- use effects ----------
  useEffect(() => {
    const params = { status: "Completed", type: "public", game: "  " };
    updateFilters(params);
    fetchTournaments(params);
  }, []);

  return (
    <Main>
      <div className="section-headding">
        <h6>Past Tournaments</h6>
      </div>
      <div className="home-container">
        <Section
          title="Browse by Games"
          data={games}
          type="game"
          navigate={Navigate}
          profile={profile}
        />
        <Section
          data={tournaments}
          type="tournament"
          navigate={Navigate}
          profile={profile}
        />
      </div>
    </Main>
  );
};

const Section = ({ title, data, type, navigate, profile }) => {
  // console.log("data--->", data);
  const settings = {
    dots: false,
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToShow: 4, // ek time me 4 item
    slidesToScroll: 1,

    responsive: [
      {
        breakpoint: 1024, // tablet
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768, // mobile
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480, // small mobile
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="section-block">
      {type === "tournament" ? (
        <>
          <div className="section-header">
            <div className="orange-header">{title}</div>
          </div>
          <div className="main-grid-class">
            {data && data.length > 0 ? (
              data.map((item, index) => {
                return (
                  <div key={index} className="tournament-card">
                    <div className="tunament-image">
                      <img
                        alt="thumbnail"
                        src={
                          isValidUrl(item?.game?.image)
                            ? item?.game?.image
                            : ImageNotAvailable
                        }
                      />
                    </div>

                    <div className="card-top-info">
                      <div className="tunament-date">
                        {moment(item.startDate).format("DD MMM YYYY | HH:mm A")}
                      </div>
                      <div className="tunament-date">Public</div>
                    </div>

                    <div className="card-tags">
                      <img src={TrofiesImage} alt="Trophies" />
                      <span>{item.name_en}</span>
                    </div>

                    <div className="tunament-slot">{`${
                      item.totalRegisteredPlayers
                    }/ ${
                      item?.teamSize *
                      (item.totalPlayerSize > 0 ? item.totalPlayerSize : 1)
                    } slots`}</div>

                    <div className="brouse-game-live-btn">
                      {/* {profile?.isSubscribed ? (
                        <Button
                          className="bid-button"
                          onClick={() =>
                            navigate(
                              `/past-tournaments/tournament-result/${item._id}`
                            )
                          }
                        >
                          View Results
                        </Button>
                      ) : (
                        <Button
                          className="join-button Fill-button"
                          onClick={(e) => {
                            e.stopPropagation();
                            navigate("/subscriptions");
                          }}
                        >
                          Upgrade To Premium
                        </Button>
                      )} */}

                      <Button
                        className="bid-button"
                        onClick={() =>
                          navigate(
                            `/past-tournaments/tournament-result/${item._id}`
                          )
                        }
                      >
                        View Results
                      </Button>
                    </div>
                  </div>
                );
              })
            ) : (
              <p>No past tournaments found</p>
            )}
          </div>
        </>
      ) : type === "game" ? (
        <>
          <div className="section-header">
            <div className="orange-header">{title}</div>
            <span
              className="view-all"
              onClick={() => navigate("/past-tournaments/games")}
            >
              {data && " View All "}
            </span>
          </div>
          <div className="browse-game-slide">
            {data && data.length > 0 ? (
              <Swiper
                modules={[Navigation]}
                navigation={true}
                loop={true}
                speed={500}
                spaceBetween={20}
                breakpoints={{
                  480: { slidesPerView: 1 },
                  768: { slidesPerView: 2 },
                  1024: { slidesPerView: 3 },
                  1200: { slidesPerView: 4 },
                }}
              >
                {data?.map((item, index) => (
                  <SwiperSlide key={index}>
                    <div
                      className="game-card"
                      // onClick={() => navigate("/past-tournaments/games")}
                      onClick={() =>
                        navigate(
                          `/past-tournaments/games/${item?.game?.name}?tab=Completed`
                        )
                      }
                    >
                      <img
                        src={
                          isValidUrl(item.game.image)
                            ? item.game.image
                            : ImageNotAvailable
                        }
                        alt="Game"
                        className="game-image"
                      />
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            ) : (
              <div className="no-games-available">
                <p>No games available</p>
              </div>
            )}
          </div>
        </>
      ) : null}
    </div>
  );
};

export default PastTournament;
